<template>
  <div id="trainings">
    <b-container fluid>
      <b-row v-if="userTrainings">
        <b-col sm="12" md="6" lg="4" v-for="t in userTrainings" :key="t.uuid" class="mb-8">
          <training-card :title="t.name" :description="t.description" :thumbnail="t.thumbnail_url" :uuid="t.uuid" />
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <h5 class="text-color-base mt-5">Brak dostępnych szkoleń.</h5>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import fetchUserTrainings from "@/mixins/elearning/fetchUserTrainings";
import TrainingCard from "../components/wod/cards/TrainingCard";

export default {
  name: 'Trainings',
  components: {TrainingCard},
  mixins: [fetchUserTrainings],
}
</script>

<style scoped>

</style>
